import React, { useEffect }  from 'react';
import { withRouter } from "react-router-dom";

import * as S from './styles';

import LogoBlack from '../../../assets/logo-agroreceita-black.svg'
import Celebration from '../../../assets/undraw_celebration.svg'
import { BodyG, BodyGSpan, BodyP, H1, TaglineG } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import maintainUtm from '../../../services/maintainUtm/index';
import InputV2 from '../../../components/input/input_v2';

export const compendioG = "@compendioG";

const Apresentacao = ({ history }) => {
    const gtmData = JSON.parse(localStorage.getItem('gtm_data'))

    useEffect(() => {
        const tour = localStorage.getItem('startTour');
        localStorage.setItem("@open", "true")

        if (tour === 'reload-needed') {
            localStorage.setItem('startTour', 'true');
            
            window.location.reload();
        }
    }, []);

    const handleStart = () => {
        localStorage.setItem('startTour', 'reload-needed');
        history.push({
            pathname: '/nova-home', 
            search: maintainUtm(),
        });
    };

    const getEmailUser = localStorage.getItem('@userinfo');
    const emailUser = JSON.parse(getEmailUser);

    return (
        <S.Container>
            <S.Wrapper>
                <img src={LogoBlack} alt="" className="logo" />

                <S.Content className="content">
                    <img src={Celebration} alt="" />

                    <H1 color={theme.colors.gray.Cinza_2}>Bem-vindo(a) ao AgroReceita! 2</H1>

                    <S.Description>
                        <BodyG color={theme.colors.gray.Cinza_5}>Aproveite todas as funções do <BodyGSpan>AgroReceita PRO</BodyGSpan> e melhore sua tomada de decisões no campo. </BodyG>

                        <BodyP color={theme.colors.red.Vermelho_erro}>Nada será enviado às Defesas Agropecuárias durante o período de teste grátis. Explore tudo sem medo.</BodyP>
                    </S.Description>

                    <S.Button className="button" onClick={handleStart}>
                        <TaglineG 
                            color={theme.colors.white.Branco}
                            fontWeight={800}
                        >
                            Começar
                        </TaglineG>
                    </S.Button>

                    <span id="email">{emailUser.username}</span>

                    <form style={{display: 'none'}} id='form-cadastro'>
                        <InputV2
                            id="nome"
                            value={gtmData?.nome}
                            label="Nome"
                            marginBottom='0px'
                        />

                        <InputV2
                            id="email"
                            value={gtmData?.email}
                            label="E-mail"
                            marginBottom='0px'
                        />

                        <InputV2
                            id="telefonecelular"
                            value={gtmData?.telefone}
                            label="Telefone/celular"
                            marginBottom='0px'
                        />
                    </form>   
                </S.Content>
            </S.Wrapper>
        </S.Container>
    );
};

export default withRouter(Apresentacao);
